import { Accordion, AccordionProps } from '@mui/material';

import styled from 'styled-components';

export const PortfolioAccordion = styled((props: Omit<AccordionProps, 'disableGutters'>) => (
  <Accordion {...props} disableGutters />
))`
  &.MuiAccordion-root {
    background-color: transparent;

    &::before {
      display: none;
    }
  }
`;
